import React, {useState, useEffect} from 'react'

import classes from './ObjectiveBar.module.css'
import AppState from '../../js/AppState';
import clsx from 'clsx';
import { states } from 'react-sdk/Objectives/ObjectiveFile';
import { observer } from 'mobx-react-lite';
import Objective from 'react-sdk/Objectives/Objective';
import { FaPlay } from 'react-icons/fa6';

/**
 *
 * @param {{rootObjective : Objective}} param0
 * @returns
 */
const ObjectiveBar = ({rootObjective}) => {

  const [currentProgress, setCurrentProgress] = useState(0);
  /*let nbCompleted = 0
  rootObjective.children.map(obj => {
    if (obj.state === states.COMPLETED || obj.state === states.FINISHED)
      nbCompleted++
  })

  let ratioProgress = nbCompleted / (rootObjective.children.length - 1)*/
  let ratioProgress = rootObjective.progress
  let percentCompleted = (ratioProgress * 100) + "%"
  // percentCompleted = "00%"
  let activeObj = rootObjective.children.find(obj => {
    return obj.state === states.ACTIVE
  })

  return (
    <div className={classes.ObjectiveBar} style={{"--percentCompleted": percentCompleted}}>
      <div className={classes.root_name} dangerouslySetInnerHTML={{__html: rootObjective.name}} />
      <div className={classes.obj_timeline_with_cursor}>
        <div className={classes.obj_timeline} style={{"--percentCompleted": percentCompleted}} >
          <div className={classes.obj_timeline_bar} />
        </div>
      </div>
      {activeObj &&
      <div className={classes.activeObj}>
        {/* <div className={classes.obj_title}>Objectif :</div> */}
        <div className={classes.obj_name} dangerouslySetInnerHTML={{__html: activeObj.name}} ></div>
      </div>}
    </div>
  );
};

export default observer(ObjectiveBar)
